import { StyleSheet } from 'react-native';

import Row from '../Row';
import { TextBody } from '../StyledText';

export default function BookingReceiptRow({
  label,
  leftComponent,
  rightComponent,
}: {
  label: string;
  leftComponent?: React.ReactNode;
  rightComponent?: React.ReactNode;
}) {
  return (
    <Row style={[styles.row, { marginTop: 12, marginBottom: 6 }]}>
      {leftComponent || <TextBody>{label}</TextBody>}
      {rightComponent}
    </Row>
  );
}

const styles = StyleSheet.create({
  row: {
    justifyContent: 'space-between',
    marginBottom: 10,
  },
});
